import {field} from '../field'
import {mergeConfig} from '../../configStore'
import {UrlField, FieldReturn} from '../../types'

export const url = (props?: UrlField, mergeProps?: Partial<UrlField>): FieldReturn =>
  field('url', mergeConfig('url', props, mergeProps))
